<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <!-- <HeaderCompanySelector/> -->
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs/>
      <div class="content mt-3">
        <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
        <div class="animated fadeIn fContainer" v-if="this.hasRole">
          <!-- content place -->
          <div class="col-lg-12 fColumn">
            <div class="card fColumn">
              <div class="card-header">
                <strong>{{$t('Users.title')}}</strong>
                <div class="float-right">
                  <template v-if="data.length<1">
                    <router-link :to="{ path: '/useredit'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('Useredit.new')}}</router-link>
                  </template>
                </div>
              </div>
              <div class="card-body card-block fColumn">
                <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :msgPre="AlertInPage.msgPre" :msgPost="AlertInPage.msgPost" :delay="AlertInPage.delay"/>
                <div class="fContent">
                  <TableDatatableJs :head="head" :data="data"/>

                </div>
              </div>
            </div>
          </div>

        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>
</template>

<script>
  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import TableDatatableJs from '@/components/TableDatatableJs.vue';
  import MenuToggle from '@/components/MenuToggle.vue';
  import Helper from '@/helper/Helper';
  import Api from '@/api/Api';
  import AlertInPage from '@/components/AlertInPage.vue';

  //  id_store 	wsid 	text
  export default {
    name: 'Companies',
    data() {

      return {
        moduleRights: []
        , Helper: Helper
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 2500,
        }
        ,

        data: [],
        head: [
          {
            title: "Users.dttitle",
            data: "id",
            link: true,
            linkurl: "useredit",
            linkclass: "text-nowrap",
            linkiconclass: "menu-icon fa fa-edit btn-link",
            linktext: "", // companies.linktext
          }
          , {
            key: "firstName",
            title: "Useredit.firstName"
          }
          , {
            key: "lastName",
            title: "Useredit.lastName"
          }
          , {
            key: "email",
            title: "Useredit.email"
          }
          , {
            key: "role",
            title: "Useradminedit.role"
          }
          , {
            key: "active",
            i18Key: "global.yesno",
            title: "Useredit.active"
          }
          , {
            key: "storageusage",
            title: "Useredit.storageusage",
            render: function (data, type, dataRow, meta) {
              let dataRet = "";
              try {
                const dataNumber = Helper.Number(data);
                if (dataNumber / 1024 / 1024 > 0) {
                  const NumberRet = Helper.getRoundedNumber(dataNumber / 1024 / 1024, 2);
                  dataRet = NumberRet + " Mb"
                }
              } catch (e) {
                dataRet = data;
              }
              return dataRet;
            },
          }
        ]
        , breadcrumbstitle: 'Users.title'
        , breadcrumbsData: [
          {
            'title': "Users.title",
          },
        ]
        , hasRole: false

      };
    },
    watch: {
      '$store.state.user': function (newVal, oldVal) {
        const modul = this;
        modul.handleRights();
      },
      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          modul.getElements();
        }
      },

    },
    mounted() {
      console.log("mounted")
      const modul = this;
      modul.handleRights();
    },
    methods: {
      handleRights(){
        const modul = this;
        if (modul.$store.state.user && modul.$store.state.user.role === "ADMIN") {
          modul.hasRole = true;
        }
      },
      getElements(){
        const modul = this;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.getUsers({id_company: modul.$store.state.id_company}).then(function (res) {
          if (res && res.result) {
            modul.data = Array.from(res.data);
            modul.AlertInPage.msg = "";
          } else {
            console.log(res)
            modul.AlertInPage.msg = "form.error";
            modul.AlertInPage.msgPost = (res.message) ? res.message : "";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
              modul.AlertInPage.msgPost = "";
            }, Number(modul.AlertInPage.delay));

          }
        });
      }
    },
    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      AlertInPage,
      TableDatatableJs,
      MenuToggle,
    },
  };
</script>








